export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11136.c39a4070.jpg";